import React from 'react';
type SectionHeadingProps = {
  id?: string;
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  align?: 'center' | 'left';
  className?: string;
};
export function SectionHeading({
  id,
  eyebrow,
  title,
  subtitle,
  align = 'center',
  className = ''
}: SectionHeadingProps) {
  const isCentered = align === 'center';
  return <div className={`${isCentered ? 'mx-auto max-w-[680px] text-center' : 'max-w-[640px] text-left'} ${className}`} data-id="element-238" data-mp="3k29lwbxluh1x">
      {eyebrow && <p className={`flex items-center gap-2.5 font-display text-[12px] font-semibold uppercase tracking-[0.22em] text-clay ${isCentered ? 'justify-center' : ''}`} data-id="element-239" data-mp="gjq3s28n4rku">
          <span aria-hidden="true" className="h-px w-6 bg-clay/40" data-id="element-240" data-mp="6sc70282q5ve" />
          {eyebrow}
          <span aria-hidden="true" className="h-px w-6 bg-clay/40" data-id="element-241" data-mp="ui6ioggnpoe2" />
        </p>}

      <h2 id={id} className={`font-display text-[31px] font-bold leading-[1.14] tracking-[-0.02em] text-ink sm:text-[42px] ${eyebrow ? 'mt-4' : ''}`} data-id="element-242" data-mp="zahep88a0q1c">
        {title}
      </h2>

      {subtitle && <p className={`mt-4 text-[17px] leading-[1.65] text-muted sm:text-[18px] ${isCentered ? 'mx-auto max-w-[560px]' : 'max-w-[560px]'}`} data-id="element-243" data-mp="1ocpaafxsa4w8">
          {subtitle}
        </p>}
    </div>;
}